import React from 'react'
import "./ParallaxContent.css"

const listData = [
    {
        BoldContent:"Save Money",
        content:"Reduce overhead costs without sacrificing expertise."
    },
    {
        BoldContent:"Access to Experts",
        content:"Get professional guidance from accounting specialists."
    },
    {
        BoldContent:"Scalability",
        content:"Services grow with your business needs."
    },
    {
        BoldContent:"Cloud-Based Solutions",
        content:"Real-time access to financial data anytime, anywhere."
    },
    {
        BoldContent:"Compliance & Accuracy",
        content:"Stay compliant with tax laws and financial regulations."
    },
]

function ParallaxContent() {
  return (
    <div className='ParallaxContent-container standard-padding-space'>
        <div className='container my-5'>
            <div className='text-content '>
                <h3 className='body-heading pb-4'>Why Businesses Choose Our Outsourced Accounting Services (Maximize Efficiency, Minimize Costs)</h3>
                {
                   <div className='ps-1 mt-4 mb-3 d-flex flex-column list-container'>
                        {
                            listData.map((list)=>{
                                return(
                                    <div className='d-flex align-items-start gap-2 mb-4'>
                                        <img loading="lazy" src='/images/icons/blue-tick.png' alt='tick icon' className='img-fluid' />
                                        <p className='body-paragraph mb-0'><b>{list.BoldContent}</b> - {list.content}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </div>
        </div>
    </div>
  )
}

export default ParallaxContent